import { CropInnerCardAttributes } from './types/CropInnerCardAttributes';

import { HarvestDates, HarvestDatesProps } from './HarvestDates';
import styles from '../../../components/cards/cardAndPreview/cardAndPreview.css';
import harvestCardStyles from './HarvestCard.css';
import useHarvestCardElements from './useHarvestCardElements';

export interface HarvestInnerCardProps extends CropInnerCardAttributes {
  harvestDates: Omit<HarvestDatesProps, 'isHarvestArdDataEnabled'>;
  displayAdditionalSilageData: boolean;
  isHarvestArdDataEnabled?: boolean;
}

export const HarvestInnerCard = (params: HarvestInnerCardProps) => {
  const { harvestDates } = params;

  const components = useHarvestCardElements(params);
  
  return (
    <div className={`${styles.spacedRow} ${harvestCardStyles.harvestContainer}`}>
      {components}
      <HarvestDates
        harvestDatesLegend={harvestDates.harvestDatesLegend}
        locale={harvestDates.locale}
        showListOfDates={harvestDates.showListOfDates}
        isHarvestArdDataEnabled={params.isHarvestArdDataEnabled ?? false}
      />
    </div>
  )
}
